import { get, writable } from 'svelte/store';
import featuresJSON from '../../../../../features.json';
import { FeaturesManager, type FeatureType } from '@automapa/svelte-automapa-features-manager';

export let fm = writable(new FeaturesManager(featuresJSON));

get(fm).setDescription(
    'feature_enable_gantt_in_delivery_list',
    '(2025-05-20) feature_enable_gantt_in_delivery_list https://er.automapa.pl/issues/45495'
);

get(fm).setDescription(
    'feature_enable_gantt_couriers_dashboards',
    '(2025-05-20) feature_enable_gantt_couriers_dashboards https://er.automapa.pl/issues/45497, https://er.automapa.pl/issues/45496'
);

get(fm).setDescription(
    'feature_temporary_fetch_gantt_data_from_files',
    '(2025-06-01) Load completed route gantt data from files https://er.automapa.pl/issues/45574'
);

get(fm).setDescription(
    'feature_easyvrp_enable_import_history',
    '(2025-06-05) #45796 - [EasyVRP][1a] import arkusza zleceń historycznych https://er.automapa.pl/issues/45796'
);

get(fm).setDescription(
    'feature_enable_limit_vehicles_when_planning',
    '(2025-05-09) #45455 - [lm2] Umożliwienie użytkownikowi automatycznego ignorowania przesyłek, które nie mieszczą się w limitach pojazdu podczas przeliczania planu taktycznego https://er.automapa.pl/issues/45455'
);

get(fm).setDescription(
    'feature_create_many_auto_vehicles',
    '(2025-07-21) #46405 Umożliwienie automatycznego utworzenia dużej liczby pojazdów (na potrzeby prezentacji lub easy-vrp) https://er.automapa.pl/issues/46405'
);

get(fm).setDescription(
    'feature_vehicle_groups',
    '(2025-08-22) feature_vehicle_groups - #45102 - [lm2] Wprowadzenie grup pojazdów https://er.automapa.pl/issues/45102'
);

get(fm).setDescription(
    'feature_add_custom_config',
    '(2025-11-03) feature_add_custom_config - #48036 - Możliwość filtrowania zleceń w zleceniach/planach taktycznych/widoku planowania dla własnych wartości klienta importowanych z pliku https://er.automapa.pl/issues/48036'
);

get(fm).setDescription(
    'feature_documentation_modal',
    '(2026-07-13) feature_documentation_modal - okno pomocy z dokumentacją użytkownika pobieraną z guide.automapa.pl'
);

// // get(fm).setDescription('feature_1253_dashboard', '(2024-04-04) #1253 Dashboard (wg analytics)');
// get(fm).setDescription(
//     'feature_1355_auto_confirm',
//     '(2024-04-14) Automatyczne zatwierdzania reguł planu taktycznego (opcja do włączenia)'
// );

// export const feature_1212_manual_add_job = writable<boolean>(
//     get(fm).isEnabled('feature_1212_manual_add_job')
// );
// export const feature_1253_dashboard = writable<boolean>(
//     get(fm).isEnabled('feature_1253_dashboard')
// );
// export const feature_1355_auto_confirm = writable<boolean>(
//     get(fm).isEnabled('feature_1355_auto_confirm')
// );

fm.subscribe(value => {
    // feature_1212_manual_add_job.set(value.isEnabled('feature_1212_manual_add_job'));
    // feature_1253_dashboard.set(value.isEnabled('feature_1253_dashboard'));
    // feature_1355_auto_confirm.set(value.isEnabled('feature_1355_auto_confirm'));
});

export const features = writable<FeatureType>(get(fm).getFeatures());
features.subscribe(value => {
    Object.keys(value).forEach(key => {
        get(fm).setEnabled(key, value[key]);
    });
});
